import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinus, faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";


function ItemCartProduct({product, eliminarProducto, disminuirProducto, aumentarProducto, key}) {
    const [variants, setVariant] = useState([]);

    useEffect(() => {
        if (product) {
            let variantId = product.variant_id;
            let variantObject = product.variants.find(v => v.id === variantId);
            setVariant(variantObject.values);
        }
    }, [product]);

    const unitPrice = product.has_offer ? product.offer_price : product.price;
    const totalPrice = product.quantity * unitPrice;

    return (
        <div
            className="group flex flex-col sm:flex-row sm:items-center bg-white border border-gray-100 p-4 md:p-5 rounded-xl gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-300"
            key={key}
        >
            {/* Product Image */}
            <div className="relative flex-shrink-0">
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-gray-50 border border-gray-100">
                    <img
                        src={product.first_image}
                        alt={product.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                {/* Delete button overlay */}
                <button
                    onClick={() => eliminarProducto(product.variant_id)}
                    className="absolute -top-2 -right-2 w-7 h-7 bg-white border border-red-200 rounded-full flex items-center justify-center text-red-400 hover:bg-red-500 hover:text-white hover:border-red-500 hover:scale-110 transition-all duration-300 shadow-sm"
                    title="Eliminar producto"
                >
                    <FontAwesomeIcon icon={faTrash} className="text-xs"/>
                </button>
            </div>

            {/* Product Info */}
            <div className="flex-1 flex flex-col gap-3 min-w-0">
                {/* Name + Total Price Row */}
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                    <div className="min-w-0 flex-1">
                        <h3 className="font-bold text-base text-gray-800 truncate">
                            {product.name}
                        </h3>
                        {/* Pricing */}
                        <div className="flex items-center gap-2 mt-1">
                            {product.has_offer ? (
                                <>
                                    <span className="text-xs line-through text-red-300">
                                        Bs {product.previous_price}
                                    </span>
                                    <span className="text-sm font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                                        Bs {product.offer_price}
                                    </span>
                                </>
                            ) : (
                                <span className="text-sm font-semibold text-gray-500">
                                    Bs {product.price}
                                </span>
                            )}
                        </div>
                    </div>
                    {/* Item Total */}
                    <div className="text-right sm:ml-4 flex-shrink-0">
                        <span className="text-lg font-bold text-gray-900">
                            Bs {totalPrice.toFixed(2)}
                        </span>
                    </div>
                </div>

                {/* Variants + Quantity Controls */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    {/* Variant Badges */}
                    <div className="flex flex-wrap gap-1.5">
                        {variants.map((value, idx) => (
                            <span
                                key={idx}
                                className="inline-flex items-center bg-blue-50 text-ecoprimary1 text-xs font-medium px-2.5 py-1 rounded-full"
                            >
                                {value.attribute}: {value.value}
                            </span>
                        ))}
                    </div>

                    {/* Quantity Controls */}
                    <div className="flex items-center gap-1.5 flex-shrink-0">
                        <button
                            onClick={() => disminuirProducto(product.variant_id)}
                            className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-600 hover:bg-ecoprimary1 hover:text-white transition-all duration-200"
                        >
                            <FontAwesomeIcon icon={faMinus} className="text-xs"/>
                        </button>
                        <div className="w-12 h-8 flex items-center justify-center border-2 border-gray-200 rounded-lg text-sm font-bold text-gray-800 bg-white">
                            {product.quantity}
                        </div>
                        <button
                            onClick={() => aumentarProducto(product.variant_id)}
                            className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-600 hover:bg-ecoprimary1 hover:text-white transition-all duration-200"
                        >
                            <FontAwesomeIcon icon={faPlus} className="text-xs"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Conectamos el componente a Redux
export default connect(null, {})(ItemCartProduct);
